"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _TopicBodyContent = _interopRequireDefault(require("./TopicBodyContent"));

var _FeaturedImage = _interopRequireDefault(require("../FeaturedImage"));

function TopicBody(_ref) {
  var _ref2;

  var topic = _ref.topic,
      featuredImageSrcSet = _ref.featuredImageSrcSet,
      featuredImageSizes = _ref.featuredImageSizes,
      translatedTopicContent = _ref.translatedTopicContent,
      isTranslationInProgress = _ref.isTranslationInProgress,
      showEditor = _ref.showEditor,
      editor = _ref.editor,
      pollVotes = _ref.pollVotes,
      answeredPoll = _ref.answeredPoll,
      displayExtendedActions = _ref.displayExtendedActions,
      pollSelectionLoading = _ref.pollSelectionLoading,
      handlePollAnswer = _ref.handlePollAnswer,
      attachmentCdn = _ref.attachmentCdn,
      onShowAlert = _ref.onShowAlert,
      onPollUpdate = _ref.onPollUpdate,
      contentType = _ref.contentType,
      poll = _ref.poll,
      attachments = _ref.attachments;
  var topicId = topic.id,
      title = topic.title,
      content = topic.content,
      featuredImage = topic.featuredImage,
      featuredImageAltText = topic.featuredImageAltText,
      reportedContent = topic.reportedContent;
  var topicAttachments = (_ref2 = attachments !== null && attachments !== void 0 ? attachments : topic.attachments) !== null && _ref2 !== void 0 ? _ref2 : [];
  return (0, _preact.h)("div", null, featuredImage && (0, _preact.h)(_FeaturedImage.default, {
    src: (0, _absoluteUrlRuntime.resolveUrl)(featuredImage),
    srcSet: featuredImageSrcSet,
    sizes: featuredImageSizes,
    alt: featuredImageAltText !== null && featuredImageAltText !== void 0 ? featuredImageAltText : title,
    width: 700,
    height: 304
  }), (0, _preact.h)(_TopicBodyContent.default, {
    topicId: Number(topicId),
    topicContent: content,
    translatedTopicContent: translatedTopicContent,
    isTranslationInProgress: isTranslationInProgress,
    showEditor: showEditor,
    editor: editor,
    displayExtendedActions: displayExtendedActions,
    onShowAlert: onShowAlert,
    onPollUpdate: onPollUpdate,
    contentType: contentType,
    attachments: topicAttachments,
    attachmentCdn: attachmentCdn,
    poll: poll,
    pollVotes: pollVotes,
    answeredPoll: answeredPoll,
    pollSelectionLoading: pollSelectionLoading,
    handlePollAnswer: handlePollAnswer,
    reportedContent: reportedContent
  }));
}

var _default = TopicBody;
exports.default = _default;